import React from "react";
import { Phone } from "lucide-react";
import FormLabel from "./FormLabel";
import FormFieldError, { fieldClass } from "./FormFieldError";
import { FieldHint } from "./createEvent/CreateEventFormUi";
import { CONTACT_PHONE_HOST_HINT } from "../lib/phone";
import { useLocale } from "../lib/locale";

/**
 * Guest WhatsApp contact — optional by default, with host-visibility hint.
 */
export default function ContactPhoneField({
  value,
  onChange,
  error,
  errorId = "contact-phone-error",
  id,
  label = "WhatsApp no",
  optional = true,
  showHint = true,
  hint = CONTACT_PHONE_HOST_HINT,
  placeholder,
  testId = "contact-phone-input",
  className = "",
  inputClassName = "mt-2",
}) {
  const locale = useLocale();
  const resolvedPlaceholder = placeholder || locale.phone_placeholder || "+49 170 123 4567";

  return (
    <label className={`block ${className}`.trim()}>
      <FormLabel className="block flex items-center gap-1.5" as="span">
        <Phone className="w-3.5 h-3.5" strokeWidth={2} aria-hidden />
        {label}
        {optional ? <span className="font-normal text-ink/60">(optional)</span> : null}
      </FormLabel>
      <input
        id={id}
        className={`${fieldClass(error)} ${inputClassName}`.trim()}
        type="tel"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={resolvedPlaceholder}
        autoComplete="tel"
        aria-invalid={Boolean(error)}
        aria-describedby={error ? errorId : undefined}
        data-testid={testId}
      />
      {error ? <FormFieldError id={errorId}>{error}</FormFieldError> : null}
      {showHint ? <FieldHint className="mt-1.5 text-[12px]">{hint}</FieldHint> : null}
    </label>
  );
}
